import React from 'react'
import PropTypes from 'prop-types'
import Setting from '../../../containers/SettingContainer'
import Parser from 'html-react-parser'
import { Link } from 'react-router'
import Star from './../../../containers/StarContainer'
import { Helmet } from 'react-helmet'
import Slider from 'react-slick'
import 'react-modal-video/scss/modal-video.scss'
import ModalVideo from 'react-modal-video'

class ProductDetail extends React.Component {
  static propTypes = {
    productDetail: PropTypes.object,
    fetchPostsWithReduxProductDetail: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)

    this.handleOnclick = this.handleOnclick.bind(this)
    this.handleOnclickIf = this.handleOnclickIf.bind(this)
  }
  openModal () {
    this.setState({ isOpen: true })
  }

  handleOnclick (event) {
    window.open(this.href, 'mywin', 'left=50,top=50,width=600,height=350,toolbar=0')
    return false
  }
  handleOnclickIf (event) {
    if (!document.getElementById('td_social_networks_buttons')) {
      window.open(this.href, 'mywin', 'left=50,top=50,width=600,height=350,toolbar=0')
      return false
    }
  }

  componentDidMount () {
    window.pro1 = this.props
    this.props.fetchPostsWithReduxProductDetail(this.props.params.splat)
  }

  componentDidUpdate (prevProps, prevState) {
  }

  componentWillMount () {
    // Thực hiện một số tác vụ, hàm này chỉ thực hiện 1 lần duy nhất
    console.log('componentWillMount')

  }
  componentWillUnmount () {
    // Hàm này thực hiện một lần duy nhất, khi component sẽ unmount
    // Hàm này hữu dụng khi bạn cần xoá các timer không còn sử dụng
    console.log('componentWillUnmount')
  }
  componentWillReceiveProps (nextProps) {
    return true
    // Hàm này thực hiện liên tục mỗi khi props thay đổi
    // (1) Sử dụng để thay đổi trạng thái (state) của component phụ thuộc props
    // (2) Sử dụng các kết quả, khởi tạo biến có tính chất async. Ví dụ: Khởi tạo Google Map Api, đây là quá trình async,
    // do vậy, bạn không thể biết được khi nào khởi tạo xong, thì khi khởi tạo xong có thể truyền xuống component thông qua
    // props, và từ đó bạn có thể khởi tạo các dịch vụ khác.
    // Code mẫu:
    //# if(nextProps.mapLoaded){ //props.mapLoaded khởi tạo false
    //#     let googleMaps = this.props.googleMaps ||
    //#         (window.google && // eslint-disable-line no-extra-parens
    //#         window.google.maps) ||
    //#         this.googleMaps;

    //#     if (!googleMaps) {
    //#         console.error(// eslint-disable-line no-console
    //#          'Google map api was not found in the page.');
    //#         return;
    //#     }
    //#     this.googleMaps = googleMaps;

    //#     this.autocompleteService = new googleMaps.places.AutocompleteService();
    //#     this.geocoder = new googleMaps.Geocoder();
    //# }
  }
  shouldComponentUpdate (nextProps, nextState) {
    console.log('shouldComponentUpdate')
    return true
    // Hàm này thực hiện khi state và props thay đổi
    // Hàm này sẽ trả về kết quả true/false, bạn sẽ cần sử dụng đến hàm này để xử lý xem có cần update component không
  }

  componentWillUpdate (nextProps, nextState) {
    console.log(nextProps.params.splat)
    console.log(this.props.params.splat)
    if (nextProps.params.splat !== this.props.params.splat) {
      this.props.fetchPostsWithReduxProductDetail(nextProps.params.splat)
    }
    console.log('componentWillUpdate')
    return true
    // Hàm này thực hiện dựa vào kết quả của hàm trên (shouldComponentUpdate)
    // Nếu hàm trên trả về false, thì React sẽ không gọi hàm này
  }

  render () {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000
    }

    return (
      <section id='section-body'>
        <Helmet>
          <title>{this.props.productDetail && this.props.productDetail.name}</title>
          <meta name='keywords' content={this.props.productDetail && this.props.productDetail.keywords} />
          <meta name='description' content={this.props.productDetail && this.props.productDetail.description} />
          <meta name='title' content={this.props.productDetail && this.props.productDetail.name} />
          <script type='application/ld+json'>
            {`
            {
            '@context': 'http://schema.org/'
            '@type': 'Product',
            'name': '` + (this.props.productDetail && this.props.productDetail.name) + `',
            'image': [
              '` + (this.props.productDetail && this.props.productDetail.imglist[0]) + `',
              '` + (this.props.productDetail && this.props.productDetail.imglist[1]) + `',
              '` + (this.props.productDetail && this.props.productDetail.imglist[2]) + `'
            ],
            'description': '` + (this.props.productDetail && this.props.productDetail.description) + `',
            'mpn': '925872',
            'brand': {
              '@type': 'Thing',
              'name': 'ACME'
            },
            'aggregateRating': {
              '@type': 'AggregateRating',
              'ratingValue': '4.4',
              'reviewCount': '89'
            },
            'offers': {
              '@type': 'Offer',
              'priceCurrency': 'VNĐ',
              'price': '` + Setting.phone + `',
              'priceValidUntil': '2020-11-05',
              'itemCondition': 'http://schema.org/UsedCondition',
              'availability': 'http://schema.org/InStock',
              'seller': {
                '@type': 'Organization',
                'name': '` + Setting.companyName + `'
              }
            }}'
            `}
          </script>
        </Helmet>
        <div className='detail-top detail-top-grid no-margin'>
          <div className='container'>
            <div className='row'>
              <div className='col-sm-12 col-xs-12'>
                <div className='header-detail table-list'>
                  <div className='header-left'>
                    <ol className='breadcrumb'>
                      <li><a href='/trang-chu'><i className='fa fa-home' /></a></li>
                      <li><a href='#'>Sản phẩm</a></li>
                      <li className='active'>{this.props.productDetail && this.props.productDetail.name}</li>
                    </ol>
                    <h1>
                      {this.props.productDetail && this.props.productDetail.name.toUpperCase()}
                      <span className='label-wrap hidden-sm hidden-xs'>
                        <span className='label label-danger'>Bán</span>
                      </span>
                    </h1>
                    <address className='property-address'>
                      {this.props.productDetail && this.props.productDetail.type}
                    </address>
                  </div>
                  <div className='header-right'>
                    <ul className='actions'>
                      <li className='share-btn'>
                        <div className='share_tooltip tooltip_left fade'>
                          <a href='#' onClick={this.handleOnclick}><i className='fa fa-facebook' /></a>
                          <a href='#' onClick={this.handleOnclickIf}><i className='fa fa-twitter' /></a>
                          <a href='#' onClick={this.handleOnclick}><i className='fa fa-pinterest' /></a>
                          <a href='#' onClick={this.handleOnclick}><i className='fa fa-linkedin' /></a>
                          <a href='#' onClick={this.handleOnclick}><i className='fa fa-google-plus' /></a>
                          <a href='#'><i className='fa fa-envelope' /></a>
                        </div>
                        <span data-placement='right' data-toggle='tooltip' data-original-title='share'>
                          <i className='fa fa-share-alt' /></span>
                      </li>
                      <li>
                        <span><i className='fa fa-heart-o' /></span>
                      </li>
                    </ul>
                    <span className='item-price'>Báo giá</span>
                    <span className='item-sub-price'><i className='fa fa-phone' />
                      <a href='Tel:{Setting.phone}'>Gọi {Setting.phone}</a></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.props.productDetail && (
          <section className='section-detail-content'>
            <div className='container'>
              <div className='row'>
                <div className='col-lg-8 col-md-8 col-sm-12 col-xs-12 container-contentbar'>
                  <div className='detail-bar'>
                    <div className='detail-media detail-top-slideshow'>
                      <div className='tab-content'>
                        <div id='gallery' className='tab-pane fade in active'>
                          <span className='label-wrap visible-sm visible-xs'>
                            <span className='label label-primary'>Bán</span>
                          </span>
                          <div className='slideshow'>
                            <Slider {...settings}>
                              {this.props.productDetail && this.props.productDetail.imglist.map((img, iKey) => {
                                return (
                                  <div key={iKey}>
                                    <img src={img} width='810' height='430'
                                       alt={'Ảnh ' + (iKey + 1) + this.props.productDetail.name} />
                                  </div>
                                )
                              })}
                            </Slider>
                          </div>
                        </div>
                        <div id='map' className='tab-pane fade' />
                        <div id='street-map' className='tab-pane fade' />
                      </div>
                      <div className='media-tabs'>
                        <ul className='media-tabs-list'>
                          <li className='popup-trigger' data-placement='bottom'
                            data-toggle='tooltip' data-original-title='View Photos'>
                            <a href='#gallery' data-toggle='tab'>
                              <i className='fa fa-camera' />
                            </a>
                          </li>
                          <li data-placement='bottom' data-toggle='tooltip' data-original-title='Map View'>
                            <a href='#map' data-toggle='tab'>
                              <i className='fa fa-map' />
                            </a>
                          </li>
                          <li data-placement='bottom' data-toggle='tooltip' data-original-title='Street View'>
                            <a href='#street-map' data-toggle='tab'>
                              <i className='fa fa-street-view' />
                            </a>
                          </li>
                        </ul>
                        <ul className='actions'>
                          <li className='share-btn'>
                            <div className='share_tooltip tooltip_left fade'>
                              <a href='#' onClick={this.handleOnclick}><i className='fa fa-facebook' /></a>
                              <a href='#' onClick={this.handleOnclickIf}><i className='fa fa-twitter' /></a>
                              <a href='#' onClick={this.handleOnclick}><i className='fa fa-pinterest' /></a>
                              <a href='#' onClick={this.handleOnclick}><i className='fa fa-linkedin' /></a>
                              <a href='#' onClick={this.handleOnclick}><i className='fa fa-google-plus' /></a>
                              <a href='#'><i className='fa fa-envelope' /></a>
                            </div>
                            <span data-placement='right' data-toggle='tooltip' data-original-title='share'>
                              <i className='fa fa-share-alt' /></span>
                          </li>
                          <li>
                            <span><i className='fa fa-heart-o' /></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='property-description detail-block'>
                      {this.props.productDetail && Parser(this.props.productDetail.description)}
                    </div>
                    {this.props.productDetail.name} {this.props.productDetail && (
                      <div className='property-video detail-block'>
                        <div className='detail-title'>
                          <h2 className='title-left'>Video</h2>
                        </div>
                        <ModalVideo channel='youtube' isOpen={this.state.isOpen}
                          videoId={this.props.productDetail.youtube}
                          onClose={() => this.setState({isOpen: false})} />
                        <img onClick={this.openModal} src='https://img.youtube.com/vi/1YmMC2BY498/0.jpg' />
                        {/*<div className='video-block'>*/}
                          {/*<a href={this.props.productDetail && (this.props.productDetail.youtube*/}
                            {/*? this.props.productDetail.youtube : 'https://www.youtube.com/watch?v=1YmMC2BY498')}*/}
                            {/*data-fancy='property_video'*/}
                            {/*title='Video giới thiệu sản phẩm'>*/}
                            {/*<span className='play-icon'><img src={this.props.productDetail &&*/}
                              {/*(this.props.productDetail.youtubeImgSmall*/}
                              {/*? this.props.productDetail.youtubeImgSmall : 'http://placehold.it/750x388')}*/}
                              {/*alt={'Video giới thiệu sản phẩm ' +*/}
                                  {/*this.props.productDetail.name.toUpperCase()}*/}
                              {/*width='70' height='50' /></span>*/}
                            {/*<img src={this.props.productDetail && (this.props.productDetail.youtubeImgBig*/}
                              {/*? this.props.productDetail.youtubeImgBig : 'http://placehold.it/750x388')}*/}
                              {/*alt={'Ảnh thumb' + this.props.productDetail.name} className='video-thumb' />*/}
                          {/*</a>*/}
                        {/*</div>*/}
                      </div>
                    )}
                    <div className='next-prev-block clearfix'>
                      {this.props.productDetail && this.props.productDetail.productpre.length !== 0
                        ? (<div className='prev-box pull-left'>
                          <div className='media'>
                            <div className='media-left'>
                              <a href='#'>
                                <img src={this.props.productDetail.productpre.img}
                                  className='media-object img-thumbnail'
                                  alt={'Ảnh thumb' + this.props.productDetail.name} width='99' height='99' />
                              </a>
                            </div>
                            <div className='media-body media-middle'>
                              <h3 className='media-heading'><Link to={this.props.productDetail.productpre.url}>
                                <i className='fa fa-angle-left' />
                                {this.props.productDetail.productpre.name.toUpperCase()}</Link>
                              </h3>
                              <h4>{this.props.productDetail.productpre.shortDescription}</h4>
                            </div>
                          </div>
                        </div>) : null}
                      {this.props.productDetail && this.props.productDetail.productnext.length !== 0
                        ? (<div className='next-box pull-right'>
                          <div className='media'>
                            <div className='media-body media-middle text-right'>
                              <h3 className='media-heading'>
                                <Link to={this.props.productDetail.productnext.url}>
                                  {this.props.productDetail.productnext.name.toUpperCase()}
                                  <i className='fa fa-angle-right' />
                                </Link>
                              </h3>
                              <h4>{this.props.productDetail.productnext.shortDescription}</h4>
                            </div>
                            <div className='media-right'>
                              <a href='#'>
                                <img src={this.props.productDetail.productnext.img}
                                  className='media-object img-thumbnail'
                                  alt={'Ảnh thumb' + this.props.productDetail.productnext.name}
                                  width='99' height='99' />
                              </a>
                            </div>
                          </div>
                        </div>) : null}
                    </div>
                  </div>
                </div>
                <div className='col-lg-4 col-md-4 col-sm-6 col-xs-12 col-md-offset-0 col-sm-offset-3 container-sidebar'>
                  <aside id='sidebar'>
                    {this.props.productDetail && this.props.productDetail.pdf !== null
                      ? (<div className='widget widget-download'>
                        <div className='widget-top'>
                          <h3 className='widget-title'>Catalog</h3>
                        </div>
                        <div className='widget-body'>
                          <ul>
                            <li>
                              <div className='pull-left'>
                                <i className='fa fa-file-pdf-o' /> Tập tin PDF
                              </div>
                              <div className='pull-right'>
                                <a href={this.props.productDetail && this.props.productDetail.pdf}>Tải</a>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>) : null}
                    {this.props.productDetail && this.props.productDetail.productrecommend.length !== 0
                      ? (<div className='widget widget-recommend'>
                        <div className='widget-top'>
                          <h3 className='widget-title'>Giới thiệu</h3>
                        </div>
                        <div className='widget-body'>
                          {this.props.productDetail.productrecommend.map((recommendProduct, rKey) => {
                            return (
                              <div key={rKey} className='media'>
                                <div className='media-left'>
                                  <figure className='item-thumb'>
                                    <Link className='hover-effect' to={recommendProduct.urlnpm}>
                                      <img className='img-thumbnail'
                                        alt={'Ảnh thumb' + this.props.productDetail.productnext.name}
                                        src={recommendProduct.img} width='100' height='75' />
                                    </Link>
                                  </figure>
                                </div>
                                <div className='media-body'>
                                  <h3 className='media-heading'>
                                    <Link to={recommendProduct.url}>{recommendProduct.name.toUpperCase()}</Link>
                                  </h3>
                                  <div className='amenities'>
                                    {recommendProduct.shortDescription}
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>) : ''}
                    {this.props.productDetail && this.props.productDetail.productfavorite.length !== 0
                      ? (<div className='widget widget-reviews'>
                        <div className='widget-top'>
                          <h3 className='widget-title'>Yêu Thích</h3>
                        </div>
                        <div className='widget-body'>
                          {this.props.productDetail.productfavorite.map((favoriteProduct, fKey) => {
                            return (
                              <div key={fKey} className='media'>
                                <div className='media-left'>
                                  <Link to={favoriteProduct.url}>
                                    <img className='media-object img-circle img-thumbnail' src={favoriteProduct.img}
                                      alt={'Ảnh thumb' + (fKey + 1) + favoriteProduct.name} width='50' height='50' />
                                  </Link>
                                </div>
                                <div className='media-body'>
                                  <h3 className='media-heading'>
                                    <Link to={favoriteProduct.url}>{favoriteProduct.name.toUpperCase()}</Link>
                                  </h3>
                                  <Star percent={favoriteProduct.star} />
                                  {favoriteProduct.shortDescription}
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>) : ''}
                  </aside>
                </div>
              </div>
            </div>
          </section>
        )}

      </section>
    )
  }
}

export default ProductDetail



// WEBPACK FOOTER //
// ./src/routes/ProductDetail/components/ProductDetail.js